import { StepIcon } from './step-icon'
import { StepLabel } from './step-label'

export function Step({
  stepNumber,
  label,
  route,
  active,
  finished,
  skipped,
  flagged,
  flagSeverity,
  lockedReason,
}: {
  stepNumber: number
  label: string
  route?: string
  active?: boolean
  finished: boolean
  skipped: boolean
  flagged?: boolean
  flagSeverity?: 'high' | 'low'
  lockedReason?: string
}) {
  return (
    <div className="flex items-center">
      <StepIcon
        stepNumber={stepNumber}
        finished={finished}
        active={active}
        skipped={skipped}
        flagged={flagged}
        flagSeverity={flagSeverity}
      />
      <StepLabel
        label={label}
        route={route}
        active={active}
        lockedReason={lockedReason}
      />
    </div>
  )
}
